export default "__VITE_ASSET__Lfg0G25a__"